<script>
import { checkOrderConfirmationStatus, sendOrderConfirmation } from '@/api/cars'
import SubmitButton from './edit/SubmitButton.vue'
import CancelButton from './edit/CancelButton.vue'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'mia-submit-button': SubmitButton
  },

  props: {
    car: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    statusCheck: null,
    checkList: [
      { field: 'is_approved', label: 'Verkauf wurde freigegeben', requires: true },
      { field: 'is_leasing', label: 'Kein Leasingfahrzeug', requires: false },
      { field: 'is_wholesale_customer', label: 'Kein Großkundengeschäft', requires: false },
      { field: 'is_agency_business_model', label: 'Kein Agenturgeschäft', requires: false },
      { field: 'order_confirmation_sent', label: 'Auftragsbestätigung noch nicht versandt', requires: false },
      { field: 'has_commission_number', label: 'Fahrzeug hat eine Kommissionsnummer', requires: true },
      { field: 'has_customer_email', label: 'Kunden E-Mail Adresse ist hinterlegt', requires: true }
    ]
  }),

  computed: {
    canSend() {
      return this.statusCheck && this.statusCheck.passes
    }
  },

  created() {
    this.check()
  },

  methods: {
    async check() {
      this.statusCheck = null
      this.$wait.start('checking order confirmation')
      const [error, response] = await checkOrderConfirmationStatus(this.car.id)
      this.$wait.end('checking order confirmation')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Fahrzeugstatus konnte nicht geprüft werden']
        })
        return
      }

      this.statusCheck = response
    },

    async send() {
      if (this.$wait.is('sending order confirmation')) {
        return
      }

      this.$wait.start('sending order confirmation')
      const [error] = await sendOrderConfirmation(this.car.id)
      this.$wait.end('sending order confirmation')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Auftragsbestätigung konnte nicht versendet werden']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Auftragsbestätigung erfolgreich versendet']
      })
      this.$emit('closed')
    },

    checkPasses(check) {
      if (!this.statusCheck) {
        return false
      }

      return this.statusCheck[check.field] === check.requires
    }
  }
}
</script>

<template>
  <mia-modal
    id="car-send-order-confirmation-modal"
    classes="v--modal flex flex-col"
    width="50%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Auftragsbestätigung versenden
      </h3>
    </mia-modal-header>

    <div class="p-4">
      <mia-wait for="checking order confirmation">
        <template #waiting>
          <div class="flex items-center justify-center py-8 flex-col">
            <mia-wave-loader />
            <div class="mt-2 text-sm">
              Fahrzeug wird geprüft...
            </div>
          </div>
        </template>

        <template #default>
          <div v-if="statusCheck">
            <ul>
              <li
                v-for="chk in checkList"
                :key="chk.field"
                class="flex items-center py-1"
              >
                <span
                  class="text-xl mr-2 inline-block w-4"
                  :class="checkPasses(chk) ? 'text-green-500' : 'text-red-500'"
                >{{ checkPasses(chk) ? '✓' : '✗' }}</span> {{ chk.label }}
              </li>
            </ul>

            <div class="mt-4">
              <p v-if="statusCheck.passes">
                Die Auftragsbestätigung kann erstellt und versendet werden.<br>Der Versand erfolgt an die am Kunden hinterlegte E-Mail Adresse: <a
                  :href="`mailto:${statusCheck.customer_email}`"
                  class="hover:underline"
                >{{ statusCheck.customer_email }}</a>
              </p>
              <p v-else>
                Die Auftragsbestätigung kann für dieses Fahrzeug nicht erstellt und versendet werden.
              </p>
            </div>
          </div>
        </template>
      </mia-wait>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Abbrechen"
        type="button"
        size="small"
        :disabled="$wait.any"
        @click="$emit('cancel')"
      />

      <mia-submit-button
        label="Versenden"
        type="button"
        class="ml-4"
        size="small"
        :is-loading="$wait.is('sending order confirmation')"
        :disabled="$wait.any || !canSend"
        @click="send"
      />
    </mia-modal-footer>
  </mia-modal>
</template>
